<template>
  <div>
    <Prerequisites v-if="!isCodeOnly" :lang-example="langExample" />
    <WriteTheCode :lang-example="langExample" />
    <RunYourCode v-if="!isCodeOnly" :lang-example="langExample" />
  </div>
</template>

<script setup lang="ts">
import { LanguageExample } from '@bifrost-dev-docs-mfe/common/types/examples';
import { computed, PropType } from 'vue';
import WriteTheCode from '@/components/example/sections/WriteTheCode.vue';
import Prerequisites from '@/components/example/sections/Prerequisites.vue';
import RunYourCode from '@/components/example/sections/RunYourCode.vue';

const props = defineProps({ langExample: { type: Object as PropType<LanguageExample>, required: true } });

const isCodeOnly = computed(() => props.langExample.code_only);
</script>
